var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deliveryProgress',{attrs:{"title":"交付主页"}})
}
var staticRenderFns = []

export { render, staticRenderFns }